<template>
    <div class="dir-ltr d-flex justify-content-center align-items-center">
      <span>{{ convertToPersian(String(minutes))  }}</span>:<span>{{ convertToPersian(String(seconds))  }} </span>:<span style="min-width: 25px;max-width: 25px;">{{ convertToPersian(String(miliSeconds))  }}</span> 
    </div>
</template>
<script setup>
import { ref,watch,defineProps,defineEmits } from "vue";
import { convertToPersian } from "./digits";
let props = defineProps(['time']);
let time = props.time;
let minutes = ref(Math.floor(time / 60))
let seconds = ref(Math.floor(time % 60))
let miliSeconds = ref(60)
let emit = defineEmits('finishCounter');
let clock = setInterval(() => {
    if(miliSeconds.value > 0){
        miliSeconds.value -= 1
    }else{
        miliSeconds.value = 60
    }
}, 10);
watch(miliSeconds,() => {
    if(miliSeconds.value == 0){
        // console.log(miliSeconds.value);
        if(seconds.value > 0){
            seconds.value -= 1
        }else{
            seconds.value = 59
        }
    }
})
watch(seconds,() => {
    if(seconds.value == 0){
        if(minutes.value > 0){
            minutes.value -= 1
        }else{
            clearInterval(clock)
            alert('پایان')
            emit('finishCounter')
        }
    }
})
</script>
<style scoped>
span{
    padding: .5em;
    font-family : "IranSans";
}
</style>